import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable
} from '@angular/material/table';
import { ILevelDayView } from '@create/Store/reducers/levelsDropPrizeReducer';
import { TranslatePipe } from '@ngx-translate/core';
import { evaluate } from '@shared/mathjs';

@Component({
  selector: 'app-promo-summary-table',
  templateUrl: './promo-summary-table.component.html',
  styleUrls: ['./promo-summary-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    DecimalPipe,
    TranslatePipe,
  ],
})
export class PromoSummaryTableComponent {
  @Input() dropDays: ILevelDayView[];

  displayedColumns = [
    'dayNumber',
    'dayDrops',
    'dayPrizes',
    'dayAmount',
  ];

  multipleHeaderColumns = [
    'promo',
    'totalDrops',
    'totalPrizes',
    'totalAmount',
  ];

  getTotalDropsCount(): number {
    return this.dropDays?.map(day => day.drops.length).reduce((acc, value) => acc + value, 0);
  }

  getTotalPrizes(): number {
    return this.dropDays?.map(day => day.dropPrizeSums.qtySum).reduce((acc, value) => acc + value, 0);
  }

  getTotalAmount(): number {
    return this.dropDays?.map(day => day.dropPrizeSums.totalMinPrizeSum).reduce((acc, value) => Number(evaluate(`${acc} + ${value}`)), 0);
  }

  trackByFn(index: number, item: ILevelDayView): symbol {
    return item.key;
  }
}
